import SlimSelect from '../../../lib/slim-select-custom';

export default class B2BUnitSwitch {
  private readonly form: JQuery;
  private readonly select: JQuery;

  constructor(private readonly container: JQuery) {
    this.form = this.container.find('.js-b2bunitSwitchForm');
    this.select = this.form.find('.js-b2bunitSwitchSelect');

    if (this.select.length) {
      this.initSlimSelect();
      this.bindSelectChange();
    }
  }

  private bindSelectChange(): void {
    this.select.on('change', (): void => {
      this.form.submit();
    });
  }

  private initSlimSelect(): SlimSelect {
    return new SlimSelect({
      select: this.select[0],
      showSearch: false,
    });
  }

  static init(): B2BUnitSwitch {
    return new B2BUnitSwitch($(document.body));
  }
}
